import {ChangeDetectorRef, Component, forwardRef, Input} from "@angular/core";
import {AddRowActionComponent} from "./add-row-action.component";
import {EditGridAddRowService} from "../edit-grid-add-row.service";


@Component({
    selector: "wbo-edit-grid-add-row-new",
    template: "",
    providers: [
        {provide: AddRowActionComponent, useExisting: forwardRef(() => EditGridAddRowNewComponent), multi: true}
    ]
})
export class EditGridAddRowNewComponent extends AddRowActionComponent {
    @Input() title: string = "wbo.edit.grid.add.addNew";

    constructor(private editGridAddRowService: EditGridAddRowService) {
        super();
    }

    override click(): void {
        this.newEntity()
    }

    newEntity(): void {
        this.editGridAddRowService.addNew();
    }
}
